import { Component, Input } from '@angular/core';
import { IMonthlyOptionColumn } from '../../interfaces/monthly-option-report.interface';
import { sortBy} from 'lodash';

@Component({
    selector: 'lynkd-pattern-options-monthly-table-top',
    templateUrl: './options-monthly-table-top.component.html',
    styleUrls: ['./options-monthly-table-top.component.scss']
})
export class OptionsMonthlyTableTopComponent {

    @Input()
    public attributeValue: string;
    public get columns(): Array<IMonthlyOptionColumn> {
        return this._columns;
    }

    @Input()
    public set columns(value: Array<IMonthlyOptionColumn>) {
        value = sortBy(value,['id']);
        this._columns = value;
    }

    @Input()
    public loading: boolean;


    private _columns: Array<IMonthlyOptionColumn>;
}
